import { CommonEventOptions } from '@westwing/appshell_types';

export const eventOptionsToString = (options: CommonEventOptions): string => Object.values(options).join('.');
